import { createTheme } from '@mui/material';

const svgIconTheme = createTheme({
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: 24,
        },
        fontSizeSmall: {
          fontSize: 20,
        },
      },
    },
  },
});

export default svgIconTheme;
